import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;

const view = (values = {}) => {
  const request = buildClientHistoryListRequest("afterlogin/client/clientvoucher", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const clientvoucherApiController = {
  view,
};
export default clientvoucherApiController;
